module.exports = __webpack_public_path__ + "media/5.a4df0bb5.mp3";